import { render } from "./PostTypeBlock.vue?vue&type=template&id=8415e89c"
import script from "./PostTypeBlock.vue?vue&type=script&lang=js"
export * from "./PostTypeBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/PostTypeBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8415e89c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8415e89c', __exports__)) {
    api.reload('8415e89c', __exports__)
  }
  
  module.hot.accept("./PostTypeBlock.vue?vue&type=template&id=8415e89c", () => {
    api.rerender('8415e89c', render)
  })

}


export default __exports__